import { IPassOffer } from "../../../app/api/getPassOffers";
import { postBooking } from "../../../app/api/postBooking";
import { IPassForm } from "../../../app/offers/OfferPassLeftSection";
import { BaseAction } from "../../../core/actions/BaseAction";
import { uuid } from "../../../core/utils/Uuid";
import { determineDefaultAge, getPassengerCard } from "../../../Lib/Utils/validationUtil";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PassengerPrmNeedTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookingResponse, PassengerSpecification } from "../../../Orchestrator/Types/Index";
import { IBookingRequest } from "../../../Orchestrator/Types/Types/BookingTypes";
import { prepareBookingSummaryAction } from "../Checkout/Summary/PrepareBookingSummaryAction";

export class BookPassOfferAction extends BaseAction<IBookingResponse | null, {
  selectedPassOffer: IPassOffer
}> {
  override async run(): Promise<IBookingResponse | null> {
    let result: IBookingResponse | null = null;

    const { selectedPassOffer } = this.params!;
    const passFormValuesAtom = getRecoilStateValue<IPassForm>('passFormValuesAtom');

    const offerIds: string[] = [selectedPassOffer.offerId];
    const passengerRefs: string[] = selectedPassOffer.passengerRefs || [];

    const passengerType = passFormValuesAtom?.passengerType || "adults";

    const bookingParams = {
      offers: offerIds.map((offerId: any) => ({
        offerId: offerId,
        passengerRefs: passengerRefs,
      })),
      passengerSpecifications: passengerRefs.map(ref => ({
        externalRef: ref,
        age: determineDefaultAge(passengerType),
        type: 'PERSON',
        cards: getPassengerCard(passengerType),
        ...(passengerType === "wheelchair" ? {
          prmNeeds: [PassengerPrmNeedTypeEnum.Wheelchair]
        } : {}),
        detail: null,
      })),
      externalRef: uuid(),
    };

    // Construct the IBookingRequest object from the prepared bookingParams
    const newBookingRequest: IBookingRequest = {
      offers: bookingParams.offers,
      passengerSpecifications: bookingParams.passengerSpecifications,
      externalRef: bookingParams.externalRef,
    };

    // Update the booking request state in Recoil
    updateRecoilState<IBookingRequest>('bookingRequestAtom', newBookingRequest);

    try {
      // Clear the booking response atom before making the request
      updateRecoilState('bookingResponseAtom', null);
      // Post booking data to the API
      const response = await postBooking(newBookingRequest);
      if (response.status === 'ok' && response.answer) {

        const bookingResponse = response.answer;
        // Update Recoil state with the booking response                

        updateRecoilState('bookingResponseAtom', bookingResponse);
        result = bookingResponse

        prepareBookingSummaryAction.setParams({ ...bookingResponse.booking })
        await prepareBookingSummaryAction.execute()
      }
    } catch (error: any) {
      console.error('Error processing booking:', error);
    } finally {
      return result
    }
  }
}

export const bookPassOfferAction = new BookPassOfferAction();
